/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import PropTypes from 'prop-types';
import SvgIcon from '@material-ui/core/SvgIcon';

const MCsmallcard = (props) => {
    const { className } = props;
    return (
        <SvgIcon className={className} viewBox="0 0 36 24">
            <g id="smallcard_mastercard" fillRule="evenodd" clipRule="evenodd">
                <rect x="0.947937" y="0.530853" width="35" height="23.6857" rx="3.5" fill="white" stroke="#D9D9D9" />
                <path d="M18.651 17.9084C17.4253 18.966 15.8355 19.6045 14.0983 19.6045C10.2219 19.6045 7.07953 16.4256 7.07953 12.5043C7.07953 8.58296 10.2219 5.40408 14.0983 5.40408C15.8355 5.40408 17.4253 6.04257 18.651 7.10023C19.8766 6.04257 21.4664 5.40408 23.2037 5.40408C27.08 5.40408 30.2224 8.58296 30.2224 12.5043C30.2224 16.4256 27.08 19.6045 23.2037 19.6045C21.4664 19.6045 19.8766 18.966 18.651 17.9084Z" fill="#ED0006" />
                <path d="M18.6509 17.9084C20.1601 16.6061 21.117 14.6682 21.117 12.5043C21.117 10.3404 20.1601 8.40254 18.6509 7.10023C19.8766 6.04257 21.4664 5.40408 23.2036 5.40408C27.08 5.40408 30.2224 8.58296 30.2224 12.5043C30.2224 16.4256 27.08 19.6045 23.2036 19.6045C21.4664 19.6045 19.8766 18.966 18.6509 17.9084Z" fill="#F9A000" />
                <path d="M18.651 7.10027C20.1601 8.40258 21.117 10.3404 21.117 12.5043C21.117 14.6682 20.1601 16.606 18.651 17.9083C17.1419 16.606 16.185 14.6682 16.185 12.5043C16.185 10.3404 17.1419 8.40258 18.651 7.10027Z" fill="#FF5E00" />
            </g>
        </SvgIcon>
    );
};

MCsmallcard.defaultProps = { className: '' };

MCsmallcard.propTypes = { className: PropTypes.string };

export default MCsmallcard;
